if (!customElements.get('l-exit-intent-popup')) {
	class LTAExitIntentPopup extends customElements.get('l-drawer') {
		connectedCallback() {
			super.connectedCallback()
			this.initExitIntent()
		}

		initExitIntent() {
			const STORAGE_KEY = 'site_total_viewed_time'
			const SHOWN_KEY = `l-exit-intent-popup-shown-${this.id || this.dataset.sectionId || ''}`
			const THRESHOLD = parseInt(this.dataset.enableExitIntentPopupAfterSeconds, 10) * 1000 // Minimum time on site before enabling popup
			let sessionStart = Date.now()
			let activated = false

			const getTime = () => {
				const stored = Number.parseInt(sessionStorage.getItem(STORAGE_KEY), 10)
				return Number.isNaN(stored) ? 0 : stored
			}

			const setTime = (val) => sessionStorage.setItem(STORAGE_KEY, String(val))

			const tryEnable = () => {
				if (activated) return
				const elapsed = Date.now() - sessionStart
				const total = getTime() + elapsed
				if (total >= THRESHOLD) {
					this.setupShowOnReturn() // Allow showing popup after eligibility
					activated = true
				}
			}

			if (getTime() >= THRESHOLD) {
				this.setupShowOnReturn()
				activated = true
			} else {
				document.addEventListener('visibilitychange', () => {
					if (document.hidden) {
						const elapsed = Date.now() - sessionStart
						setTime(getTime() + elapsed)
						tryEnable()
					} else {
						sessionStart = Date.now()
					}
				})

				window.addEventListener('beforeunload', () => {
					const elapsed = Date.now() - sessionStart
					setTime(getTime() + elapsed)
				})

				const intervalId = setInterval(() => {
					tryEnable()
					if (activated) clearInterval(intervalId)
				}, 500)
			}
		}

		// Show popup when tab is re-focused after being eligible, only once per session
		setupShowOnReturn() {
			const SHOWN_KEY = `l-exit-intent-popup-shown-${this.id || this.dataset.sectionId || ''}`

			document.addEventListener('visibilitychange', () => {
				if (!document.hidden) {
					if (!sessionStorage.getItem(SHOWN_KEY)) {
						sessionStorage.setItem(SHOWN_KEY, 'true')
						super.drawer_open()
					}
				}
			})
		}
	}

	customElements.define('l-exit-intent-popup', LTAExitIntentPopup)
}

